/**
 * Version of the extension SDK (`@distribuai/sdk`), not of the platform build.
 * Bump the major for any breaking change to `public-api.ts` (a removed or changed
 * export, changed component props); extensions declare the range they support.
 */
export const SDK_VERSION = '1.7.0' // 1.1: useTenant · 1.2: Modal · 1.3: DataTable activeRowKey/rowProps, FilterBar/Pagination density · 1.4: DataTable sticky columns/fillMinWidth/stickyActions · 1.5: DataTable sticky header/maxHeight, several pinned columns · 1.6: MultiSelect search (searchLabel/noMatchesLabel) · 1.7: ExtensionView placement (user menu) and audience (demo)
